import { render, staticRenderFns } from "./AvailableShiftsContent.vue?vue&type=template&id=56baa963"
import script from "./AvailableShiftsContent.vue?vue&type=script&lang=js"
export * from "./AvailableShiftsContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports